module.exports = __webpack_public_path__ + "img/part2-bg2.5822b687.png";